import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import profile from '../assets/images/profile.png';
import ChatIcon from "../assets/images/chat-white.png";


const styles = {
    avatar: {
        color: '#fff',
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
    },
    imageStyles: {
        width: '45px',
        height: '45px',
        borderRadius: '50%',
        objectFit: 'cover'
    }
};


const ContactAvatar = (props) => {
    const {contact, wrapperStyles, inChat, inMenu, inChatMenu} = props;

    if (contact === undefined || contact === null) {
        return null
    }

    const platform = contact && contact.platform ? contact.platform : 'COMPANY';

    const backgroundColor = 'rgb(4, 62, 92)';

    const firstName = contact.firstName ? contact.firstName : '';
    const lastName = contact.lastName ? contact.lastName : '';
    const email = contact.email ? contact.email : '';

    let avatarText = email.substring(0, 1).toUpperCase();
    if (firstName !== '') {
        avatarText = firstName.substring(0, 1).toUpperCase() + lastName.substring(0, 1).toUpperCase();
    }

    let thumbUrl = contact.thumbUrl ? contact.thumbUrl : null;
    const thumbIsPresent = thumbUrl != null;


    if (inChat && !inMenu) {
        styles.avatar.width = '45px'
        styles.avatar.height = '45px'
    }

    if (inMenu) {
        styles.avatar.width = '30px'
        styles.avatar.height = '30px'
    }

    const avatarContent = thumbIsPresent ? (<img src={thumbUrl} style={styles.imageStyles}/>)
        : platform === 'COMPANY' ? (
                <Fragment>
                    {avatarText}
                </Fragment>
            )
            : (
                <img src={profile} alt="edit" width={24} height={24}/>
            );

    return (
        <div>
            {inMenu && (
                <div style={[!thumbIsPresent ? {backgroundColor: backgroundColor} : '', styles.avatar, wrapperStyles]}>
                    {avatarContent}
                </div>
            )}
            {inChatMenu && (!thumbIsPresent ? platform === 'COMPANY' ?
                        <div
                            style={[!thumbIsPresent ? {backgroundColor: backgroundColor} : '', styles.avatar, wrapperStyles]}>
                            <Fragment>
                                {avatarText}
                            </Fragment>
                        </div>
                        :
                        <img src={profile} width={45} height={45}/> :
                    <div
                        style={[!thumbIsPresent ? {backgroundColor: backgroundColor} : '', styles.avatar, wrapperStyles]}>
                        {avatarContent}
                    </div>
            )}
            {inChat && (contact.bot ?
                    <div
                        style={{...styles.avatar, backgroundColor: backgroundColor}}>
                        <img src={ChatIcon} alt="edit" width={24} height={24}/>
                    </div>
                    :
                    !thumbIsPresent ? platform === 'COMPANY' ?
                            <div
                                style={[!thumbIsPresent ? {backgroundColor: backgroundColor} : '', styles.avatar, wrapperStyles]}>
                                <Fragment>
                                    {avatarText}
                                </Fragment>
                            </div>
                            :
                            <img src={profile} alt="edit" width={40} height={40}/> :
                        <div
                            style={[!thumbIsPresent ? {backgroundColor: backgroundColor} : '', styles.avatar, wrapperStyles]}>
                            {avatarContent}
                        </div>
            )}
        </div>


    );
};

ContactAvatar.propTypes = {
    contact: PropTypes.object.isRequired,
    wrapperStyles: PropTypes.object,
};

ContactAvatar.defaultProps = {
    wrapperStyles: {},
};

export default Radium(ContactAvatar);



// WEBPACK FOOTER //
// ./src/components/ContactAvatar.jsx